export const CHEMICAL_SYMBOLS = {
  ferricIon: "Fe³⁺",
  aluminiumIon: "Al³⁺",
  polyaluminiumChloride: "PaCl",
  ferricChloride: "FeCl₃",
  H2SO4: "H₂SO₄",
};

export const COAGULANT_CHEMICAL_MAPPING = {
  [CHEMICAL_SYMBOLS.ferricIon]: "FeCl3",
  [CHEMICAL_SYMBOLS.aluminiumIon]: "PaCl",
};

export const CHEMICAL_NAMES = {
  sulfuricAcid: "Sulfuric Acid",
  hydrochloricAcid: "Hydrochloric Acid",
  sodiumHydroxide: "Sodium Hydroxide",
};

export const CHEMICAL_TYPES = {
  base: "Base",
  acid: "Acid"
};
